import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8098de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-aside-collapsed", "data-fullscreen"]
const _hoisted_2 = { class: "pe-layout-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderNav = _resolveComponent("HeaderNav")!
  const _component_MenuPc = _resolveComponent("MenuPc")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pe-layout-pc-wrapper",
    "data-aside-collapsed": _ctx.isAsideCollapsed,
    "data-fullscreen": _ctx.isFullscreen
  }, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_HeaderNav, {
          showBorder: true,
          fixed: ""
        }, null, 512), [
          [_vShow, !_ctx.isFullscreen]
        ]),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_MenuPc, { onCollapseStatusChange: _ctx.handleCollapseStatusChange }, null, 8, ["onCollapseStatusChange"]), [
              [_vShow, !_ctx.isFullscreen]
            ]),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 8, _hoisted_1))
}